import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useHeaderFilters } from '@/features/header-filters';

import { useReceiveFilters } from '../model';
import { ReceiveFilters } from './receive-filters';
import { ReceivePage } from './receive-page';

export function ReceiveWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig, setSearchConfig } = useHeaderFilters();

  const {
    urlState,
    searchQuery,
    activeFiltersCount,
    activeFilters,
    isFiltersDirty,
    hasDefaultFilters,
    organizationOptions,
    isLoadingOrganizations,
    setOrganizationSearch,
    setSelectedOrganization,
    handleFilterChange,
    handleSearchChange,
    handleReset,
    handleApplyFilters
  } = useReceiveFilters();

  useEffect(() => {
    setSearchConfig({
      defaultValue: searchQuery,
      placeholder: t('common.search', 'Search among relevant properties'),
      onChange: handleSearchChange,
      enabled: true
    });
  }, [handleSearchChange, searchQuery, setSearchConfig, t]);

  useEffect(() => {
    const filterContent = (
      <ReceiveFilters
        filters={urlState}
        onFilterChange={handleFilterChange}
        organizationOptions={organizationOptions}
        selectedOrganization={urlState.organization}
        onOrganizationChange={setSelectedOrganization}
        onOrganizationSearchChange={setOrganizationSearch}
        isLoadingOrganizations={isLoadingOrganizations}
      />
    );

    setFilterConfig({
      id: 'receive-filters',
      title: t('receive.dashboard.filters.title', 'Filter Receive'),
      content: filterContent,
      activeCount: activeFiltersCount,
      activeFilters,
      onReset: handleReset,
      onApply: handleApplyFilters,
      onClearAll: handleReset,
      isApplyDisabled: !isFiltersDirty,
      isResetDisabled: hasDefaultFilters
    });
  }, [
    activeFiltersCount,
    activeFilters,
    handleApplyFilters,
    handleFilterChange,
    handleReset,
    hasDefaultFilters,
    isFiltersDirty,
    isLoadingOrganizations,
    organizationOptions,
    setFilterConfig,
    setOrganizationSearch,
    setSelectedOrganization,
    t,
    urlState
  ]);

  return <ReceivePage />;
}
